import React from 'react';
import clsx from 'clsx';
import type { BonusBar } from './sheetMaths';

const BAR_BG: Record<BonusBar['kind'], string> = { shield: 'bg-ut-sky', natural: 'bg-ut-ok', reset: 'bg-ut-bad' };
const BAR_TEXT: Record<BonusBar['kind'], string> = { shield: 'text-ut-sky', natural: 'text-ut-ok', reset: 'text-ut-bad' };

/** Column chart of the XP bonus per game back. Heights are relative to `scaleTo` (the bonus now). */
export const BonusBarChart: React.FC<{ bars: BonusBar[]; scaleTo: number }> = ({ bars, scaleTo }) => {
  const top = Math.max(scaleTo, ...bars.map((b) => b.pct), 1);
  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex h-[90px] items-end gap-1.5">
        {bars.map((b) => (
          <div key={b.game} className="flex h-full flex-1 flex-col items-center justify-end gap-1">
            <span className={clsx('text-[11px] font-bold', BAR_TEXT[b.kind])}>+{b.pct}%</span>
            <span
              className={clsx('w-full rounded-t', BAR_BG[b.kind])}
              style={{ height: `${Math.max(2, Math.round((b.pct / top) * 70))}px` }}
              title={`Game ${b.game} back: ${b.streak}-game streak, +${b.pct}% XP`}
            />
          </div>
        ))}
      </div>
      <div className="flex gap-1.5" aria-hidden>
        {bars.map((b) => (
          <span key={b.game} className="flex-1 text-center text-[11px] text-ut-mut">
            G{b.game}
          </span>
        ))}
      </div>
    </div>
  );
};
